export default __webpack_public_path__ + "static/media/rightarrow.5fc4a970.svg";